import { render, staticRenderFns } from "./spot.vue?vue&type=template&id=65ac46f4&scoped=true&"
import script from "./spot.vue?vue&type=script&lang=js&"
export * from "./spot.vue?vue&type=script&lang=js&"
import style0 from "./spot.vue?vue&type=style&index=0&id=65ac46f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac46f4",
  null
  
)

export default component.exports